export const USER_ATTRIBUTES = {
  HIDE_COLLABORATION_SIDEBAR_EMBEDDED_COMMENTS: {
    key: 'hideCollaborationSidebarEmbeddedComments',
    defaultValue: 'false'
  }
};
export const getUserAttributesArray = () => [...Object.values(USER_ATTRIBUTES)];